import 'babel-polyfill';
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import _ from 'lodash';

import App from './App.vue';
import config from './config';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

axios.defaults.baseURL = config.host;
axios.defaults.withCredentials = true;

Object.defineProperty(Vue.prototype, '$moment', { value: moment });
Object.defineProperty(Vue.prototype, '$_', { value: _ });

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
